export default __webpack_public_path__ + "static/media/IF_MyTeamStrengths_StrengthDesc_05.da625f4d.jpg";